<template>
  <div class="WechatUsers">
    <header>
      <el-button
        type="primary"
        style="margin-right: 100px;"
        @click="$refs.addWechatUser.open(0, 1)"
      >添加</el-button>
      <el-input
        v-model="wechatUsersQuery.wechat_name"
        placeholder="公众号名称"
        style="width: 200px; margin-right: 10px;"
      />
      <el-input
        v-model="wechatUsersQuery.user_name"
        placeholder="投手名称"
        style="width: 200px; margin-right: 10px;"
      />
      <el-button
        type="primary"
        style="margin-right: 5px"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh"
        @click="reset"
      >重置</el-button>
    </header>
    <main>
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="app_id"
          label="Appid"
          min-width="150"
        />
        <el-table-column
          prop="account_name"
          label="公众号"
          min-width="150"
        />
        <el-table-column
          prop="data"
          label="分配详情"
          min-width="150"
        >
          <template scope="scope">
            <span>{{ scope.row.nickname }}：&nbsp;</span>
            <span>{{ scope.row.start_time }}<i style="color: #ccc;">&nbsp;—&nbsp;</i></span>
            <span>{{ scope.row.end_time }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="date"
          label="操作"
          min-width="70"
          align="center"
        >
          <template scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="$refs.addWechatUser.open(scope.row, 2)"
            >添加</el-button>
            <el-button
              size="mini"
              @click="$refs.modifyWechatUser.open(scope.row)"
            >修改</el-button>
            <el-button
              size="mini"
              @click="openHistoryDialog(scope.row)"
            >历史</el-button>
          </template>
        </el-table-column>
      </el-table>
    </main>
    <add-wechat-user
      ref="addWechatUser"
      :select-data="tableData"
      @confirm="addUserConfirm"
    />
    <modify-wechat-user
      ref="modifyWechatUser"
      @confirm="modifyConfirm"
    />
    <history-wechat-userData ref="historyWechatUserData" />
    <pagination-right
      :total="tableData.total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getList, addManagement, modifyData, getHistoryData } from '@/api/report/wechatUsers.js'
import AddWechatUser from './components/wechatUsers/AddWechatUser.vue'
import ModifyWechatUser from './components/wechatUsers/ModifyWechatUser.vue'
import HistoryWechatUserData from './components/wechatUsers/HistoryWechatUserData.vue'
export default {
  name: 'WechatUsers',
  components: {
    PaginationRight,
    AddWechatUser,
    ModifyWechatUser,
    HistoryWechatUserData
  },
  data() {
    return {
      tableData: {},
      wechatUsersQuery: {
        user_name: null,
        wechat_name: null,
        page: null,
        page_size: null
      },
      data: {},
      loading: false // 加载效果
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    // 获取列表数据
    getListData() {
      this.loading = true
      getList(this.wechatUsersQuery).then(res => {
        this.tableData = res.data
        this.data.startTime = res.data.list.created_at
        this.data.endTime = res.data.list.end_time
        this.loading = false
      })
    },
    // 分页
    fetchPageSize(e) {
      this.wechatUsersQuery.page_size = e
      this.getListData()
    },
    fetchCurrentPage(e) {
      this.wechatUsersQuery.page = e
      this.getListData()
    },
    // 搜索数据
    search() {
      this.wechatUsersQuery.page = 1
      this.getListData()
    },
    // 重置搜索框
    reset() {
      this.wechatUsersQuery = {}
      this.getListData()
    },
    // 添加公众号管理员
    addUserConfirm(data) {
      addManagement(data).then(res => {
        this.getListData()
        this.$message({
          message: '添加成功',
          type: 'success'
        })
      })
    },
    // 修改公众号管理员信息
    modifyConfirm(id, data) {
      modifyData(id, data).then(res => {
        this.getListData()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
      })
    },
    openHistoryDialog(data) {
      getHistoryData(data.id).then(res => {
        this.$refs.historyWechatUserData.open(res.data)
      })
    }
  }
}
</script>

<style scoped lang="less">
.WechatUsers {
  min-width: 1200px;
  padding: 30px 60px;
  header {
    display: flex;
    margin-bottom: 20px;
    .el-select {
      margin-right: 20px;
    }
  }
}
</style>
